import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const StoriesSearchParamsSchema = createPaginationSchema({
  defaultPageSize: 10,
  allowedPageSizes: [5, 10, 25],
}).concat(
  createSortSchema(['createdAt'] as const, {
    defaultSortBy: 'createdAt',
    defaultSortOrder: 'desc',
  })
);
